module.exports = __webpack_public_path__ + "static/media/history5.03f782fb.png";